import React from 'react'

import type { DomainUserRoleStringEnum } from '@/shared/api'

import { useAuthProfileValue } from '../model/hooks/use-auth-profile.value'

interface RolesGuardProps {
    children: React.ReactNode
    roles: DomainUserRoleStringEnum[]
    fallback?: React.ReactNode
}

export const RolesGuard = ({ children, roles, fallback }: RolesGuardProps) => {
    const { profile } = useAuthProfileValue()

    if (profile?.role && roles.includes(profile.role)) {
        return children
    }

    return fallback ?? null
}
